// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Bundle from "./bundle.js"
import BundleOrderLineElement from "./bundle-order-line-element.js"
import TenantPhotoProduct from "./tenant-photo-product.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "tenant_photo_product_id": {
      "column": {
        "default": null,
        "name": "tenant_photo_product_id",
        "null": false,
        "type": "uuid"
      },
      "name": "tenant_photo_product_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "BundleOrderLine",
  "collectionKey": "bundle_order_lines",
  "collectionName": "bundle_order_lines",
  "i18nKey": "bundle_order_line",
  "camelizedLower": "bundleOrderLine",
  "name": "BundleOrderLine",
  "nameDasherized": "bundle-order-line",
  "pluralName": "bundle_order_lines",
  "ransackable_associations": [
    {
      "className": "Bundle",
      "collectionName": "bundles",
      "foreignKey": "bundle_id",
      "name": "bundle",
      "macro": "belongs_to",
      "resource_name": "Bundle",
      "through": null
    },
    {
      "className": "BundleOrderLineElement",
      "collectionName": "bundle_order_line_elements",
      "foreignKey": "bundle_order_line_id",
      "name": "bundle_order_line_elements",
      "macro": "has_many",
      "resource_name": "BundleOrderLineElement",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "OrderLine",
      "collectionName": "order_lines",
      "foreignKey": "orderable_id",
      "name": "order_line",
      "macro": "has_one",
      "resource_name": "OrderLine",
      "through": null
    },
    {
      "className": "PhotoProduct",
      "collectionName": "photo_products",
      "foreignKey": "photo_product_id",
      "name": "photo_product",
      "macro": "has_one",
      "resource_name": "PhotoProduct",
      "through": "tenant_photo_product"
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "product_id",
      "name": "product",
      "macro": "has_one",
      "resource_name": "Product",
      "through": "photo_product"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "tenant_photo_product_id",
      "name": "tenant_photo_product",
      "macro": "belongs_to",
      "resource_name": "TenantPhotoProduct",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "bundle_id",
      "column": {
        "default": null,
        "name": "bundle_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_photo_product_id",
      "column": {
        "default": null,
        "name": "tenant_photo_product_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Bundle",
      "collectionName": "bundles",
      "foreignKey": "bundle_id",
      "name": "bundle",
      "macro": "belongs_to",
      "resource_name": "Bundle",
      "through": null
    },
    {
      "className": "BundleOrderLineElement",
      "collectionName": "bundle_order_line_elements",
      "foreignKey": "bundle_order_line_id",
      "name": "bundle_order_line_elements",
      "macro": "has_many",
      "resource_name": "BundleOrderLineElement",
      "through": null
    },
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "tenant_photo_product_id",
      "name": "tenant_photo_product",
      "macro": "belongs_to",
      "resource_name": "TenantPhotoProduct",
      "through": null
    }
  ],
  "paramKey": "bundle_order_line",
  "primaryKey": "id"
}

/** Frontend model for BundleOrderLine. */
export default class BundleOrderLine extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  tenantPhotoProductId() {
    return this.readAttributeUnderscore("tenant_photo_product_id")
  }

  /** @returns {boolean} */
  hasTenantPhotoProductId() {
    const value = this.tenantPhotoProductId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./bundle.js").default | null} */
  bundle() {
    return this._readBelongsToReflection({modelClass: Bundle, reflectionName: "bundle"})
  }

  /** @returns {Promise<import("./bundle.js").default | null>} */
  loadBundle() {
    if (!("bundleId" in this)) throw new Error("Foreign key method wasn't defined: bundleId")

    const id = this.bundleId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "bundle",
        model: this,
        modelClass: Bundle
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./bundle.js").default | null>} */
  ensureBundleLoaded() {
    return this.ensureAssociationLoaded("bundle")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./bundle-order-line-element.js").default>} */
  bundleOrderLineElements() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["bundle_order_line_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "bundle_order_line_elements",
        model: this,
        modelClass: BundleOrderLineElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./bundle-order-line-element.js").default>>} */
  loadBundleOrderLineElements() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["bundle_order_line_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "bundle_order_line_elements",
        model: this,
        modelClass: BundleOrderLineElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./bundle-order-line-element.js").default>>} */
  ensureBundleOrderLineElementsLoaded() {
    return this.ensureAssociationLoaded("bundle_order_line_elements")
  }

  /** @returns {import("./tenant-photo-product.js").default | null} */
  tenantPhotoProduct() {
    return this._readBelongsToReflection({modelClass: TenantPhotoProduct, reflectionName: "tenant_photo_product"})
  }

  /** @returns {Promise<import("./tenant-photo-product.js").default | null>} */
  loadTenantPhotoProduct() {
    if (!("tenantPhotoProductId" in this)) throw new Error("Foreign key method wasn't defined: tenantPhotoProductId")

    const id = this.tenantPhotoProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant_photo_product",
        model: this,
        modelClass: TenantPhotoProduct
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant-photo-product.js").default | null>} */
  ensureTenantPhotoProductLoaded() {
    return this.ensureAssociationLoaded("tenant_photo_product")
  }
}
